module.exports = __webpack_public_path__ + "img/logo-sm.c3e3f2f7.jpg";